export default {"src":"/_next/static/image/public/images/Grey_Circle.f0db1ff558796b3cd7d47a14b1de015d.svg","height":16,"width":16};